import { DateTime } from 'luxon';
import groupBy from 'lodash-es/groupBy';

export class DisruptionUtils {
    static isInFuture(disruption) {
        const now = DateTime.now().setZone('Europe/London');
        const end = DateTime.fromISO(disruption.attributes.endDateLocal, { zone: 'Europe/London' })
            .set({ hour: 23 })
            .set({ minute: 59 })
            .set({ second: 59 });

        return end >= now;
    }

    static getGroupedDisruptions(disruptions) {
        const sortedDisruptions = disruptions.sort((a, b) => a.attributes.startDateLocal
            .localeCompare(b.attributes.startDateLocal))
            .sort((a, b) => a.attributes.endDateLocal.localeCompare(b.attributes.endDateLocal))
            .filter((e) => DisruptionUtils.isInFuture(e));
        return groupBy(
            sortedDisruptions,
            (disruption) => `${disruption.attributes.startDateLocal}--${disruption.attributes.endDateLocal}`,
        );
    }

    static getDisruptions(disruptions) {
        const groups = DisruptionUtils.getGroupedDisruptions(disruptions);
        const groupedDisruptions = [];
        Object.values(groups).forEach((group: Array<Disruption>) => {
            const descriptions = [];
            const tocs = [];
            group.forEach((disruption) => {
                descriptions.push(disruption.attributes.description);
                tocs.push(disruption.attributes.toc);
            });
            groupedDisruptions.push({
                startDateLocal: group[0].attributes.startDateLocal,
                endDateLocal: group[0].attributes.endDateLocal,
                descriptions: Array.from(new Set(descriptions)),
                tocs: Array.from(new Set(tocs)),
                individualObjects: group,
            });
        });
        return groupedDisruptions;
    }
}

export interface Disruption {
    attributes: DisruptionsAttributes,
    links: DisruptionLinks,
    id: String,
    type: String,
}

export interface DisruptionsAttributes {
    startDateLocal: String,
    endDateLocal: String,
    description: String,
    allowRefund: Boolean,
    publicise: Boolean,
    toc: String,
    type: String,
}

export interface DisruptionLinks {
    self: String,
}
